import { Button, Modal } from '@cimplico/components';
import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { SubscriptionTier } from '../../types/firm';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';

type UpgradePromptProps = {
    onClose: () => void;
    targetTier: SubscriptionTier;
    quota?: boolean;
};

function UpgradePrompt({ onClose, targetTier, quota = false }: UpgradePromptProps): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();
    const { isAdmin } = useIsFirmRole();

    return (
        <Modal isOpen onClose={onClose}>
            <div className="bg-white rounded-md py-8 px-16 flex flex-col items-center relative">
                <button className="absolute top-2.5 right-2.5" onClick={onClose}>
                    <XMarkIcon className="h-5 w-5 text-gray-600" />
                </button>
                <ArrowUpCircleIcon className="h-14 w-14 text-indigo-600" />
                <h3 className=" text-gray-900 font-bold text-2xl">Upgrade your plan</h3>
                {targetTier === SubscriptionTier.ESSENTIAL ? (
                    <p className="mt-4 text-gray-800 mb-6">
                        Upgrade to the <b className="text-indigo-600">Essential</b> or <b className="text-indigo-600">Professional</b> plan
                        <span> to increase your quota and access more features!</span>
                    </p>
                ) : (
                    <p className="mt-4 text-gray-800 mb-6">
                        Upgrade to the <b className="capitalize text-indigo-600">{targetTier.toLocaleLowerCase()}</b> plan{' '}
                        <span> to increase your quota and access more features!</span>
                    </p>
                )}

                <Button
                    type="primary"
                    label="Upgrade"
                    size="lg"
                    onClick={(): void => {
                        navigate(`/${shortId}/settings`);
                    }}
                    leftIcon={<ArrowUpCircleIcon />}
                    disabled={!isAdmin}
                />

                {!isAdmin && <p className="text-gray-600 mt-2 text-sm">To upgrade, please contact your firm&apos;s administrator</p>}
            </div>
        </Modal>
    );
}

export default UpgradePrompt;
